// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"453":"1e74286a","667":"d51c3b5f","977":"c24da352"}[chunkId] + ".chunk.js");